import { ApiPostRequest } from '../api';

export const state = {
  data: {
    loading: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    filter: null,
    filterOn: [],
    sortBy: 'id_photo',
    sortDesc: true,
    form_or: {
      domain: '',
      or_number: '',
    },
    form_eir: {
      domain: '',
      eir_number: '',
    },
    form_faktur: {
      domain: '',
      npwp: '',
      or_number: '',
    },
    form_tracking: {
      domain: '',
      tracking_type: '',
      doc_no: '',
      container: '',
      photo_type: 'Survey In',
    },
    result_eir: {},
    result_or: {},
    result_faktur: {},
    result_tracking: {},
  },
};

export const mutations = {
  changeLanding(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const getters = {
  form_or(state) {
    return state.data.form_or;
  },
  form_eir(state) {
    return state.data.form_eir;
  },
  form_faktur(state) {
    return state.data.form_faktur;
  },
  form_tracking(state) {
    return state.data.form_tracking;
  },
  result_or(state) {
    return state.data.result_or;
  },
  result_eir(state) {
    return state.data.result_eir;
  },
  result_faktur(state) {
    return state.data.result_faktur;
  },
  result_tracking(state) {
    return state.data.result_tracking;
  },
};

export const actions = {
  async getDataOR({ commit, state }) {
    commit('changeLanding', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(
      `${data.form_or.domain}/check-data/or`,
      data.form_or
    );
    commit('changeLanding', {
      loading: false,
      result_or: !result.error ? result.data.object : {},
    });

    return !result.error ? true : false;
  },

  async getDataEIR({ commit, state }) {
    commit('changeLanding', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(
      `${data.form_eir.domain}/check-data/eir`,
      data.form_eir
    );

    commit('changeLanding', {
      loading: false,
      result_eir: !result.error ? result.data.object : {},
    });

    return !result.error ? true : false;
  },

  async getDataFaktur({ commit, state }) {
    commit('changeLanding', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(
      `${data.form_faktur.domain}/check-data/faktur`,
      data.form_faktur
    );

    commit('changeLanding', {
      loading: false,
      result_faktur: !result.error ? result.data.object : {},
    });

    return !result.error ? true : false;
  },

  async getDataTracking({ commit, state }) {
    commit('changeLanding', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(
      `${data.form_tracking.domain}/check-data/tracking`,
      {
        ...data.form_tracking,
        q: data.search,
        limit: data.limit,
        page: data.page,
        sort: data.sortBy,
        order: data.sortDesc ? 'desc' : 'asc',
      }
    );

    commit('changeLanding', {
      loading: false,
      result_tracking: !result.error ? result.data.object : false,
      total: !result.error ? result.data.total : 0,
    });

    return !result.error ? true : false;
  },
};
